import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Product/Line/Team/Evaluate/';

const state = {};

const mutations = {};

const actions = {

  CheckTeamEvaluateTalk({commit}, view) {
    return request.PromiseCall(basePath, 'CheckTeamEvaluateTalk', view);
  },
  Evaluate({commit}, view) {
    return request.PromiseCall(basePath, 'Evaluate', view);
  },
  CheckSelectByMemberId({commit}, view) {
    return request.PromiseCall(basePath, 'CheckSelectByMemberId', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Product/Line/Team/Evaluate/index.js